import React from "react";

import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

type Props = { className?: string };

export const Code = (props: SvgIconProps & Props) => {
    return (
        <SvgIcon {...props}>
            <path d="M15.3157 18L20.9999 12L15.3157 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.68421 6L3 12L8.68421 18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
};
